import {getPlatform} from '@/util/tool';

export default {
    methods: {

    },
    computed: {
        contextData() {
            return {
                isCp: 1,
                channelId: this.$store.state.channelId,
                userId: this.$route.query.userId,
                openId: this.$route.query.openId,
                userKey: this.$route.query.userKey
            };
        },
        isAPP() {
            let t = getPlatform()
            return t.isYixinliApp || t.isCeShiApp;
        },
        isAliMp() {
            const { isWebviewMp, isAliPay} = this.$route.query
            // 4925 壹心理支付宝小程序
            let r = (navigator.userAgent.indexOf('AlipayClient') > -1)
              && ((isWebviewMp == 1 && isAliPay == 1) || this.channelId == 4925)
            // let r = true
            // console.log('=== vue === isAliMp', r)
            return r
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        userPersonInfo () {
            return this.$store.state.userPersonInfo;
        },
        channelId(){
             return this.$store.state.channelId || this.$route.query.channelId
        },
        channelName(){
          let r = ''
          let o = {
            514: '壹心理app渠道',
            4925: '测评支付宝小程序渠道',
            513: '壹心理m站',
          }
          if (o[+this.channelId]) {
            r = o[+this.channelId]
          }
          return r
        },
        vipInfo(){
            return this.$store.state.vipInfo;
        },
        isVip(){
            return this.$store.state.vipInfo.status
        },
        userKey(){
          return this.userInfo.userKey||this.$route.query.userKey
        },
        ACTIVTYSLASTYPE(){
          let beginData1 = new Date('2019/12/29 00:00').getTime()
          let beginData2 = new Date('2019/12/30 00:00').getTime()
          let beginData3 = new Date('2019/12/31 00:00').getTime()
          let beginData4 = new Date('2020/01/01 00:00').getTime()
          let newData = new Date().getTime()
          if(newData > beginData4){
            return 4
          }else if (newData > beginData3) {
            return 1
          }else if(newData > beginData2){
            return 2
          }else if(newData > beginData1){
            return 3
          }else{
            return 0
          }
        },
        isActivity20201111() {
            let r = false
            let scalePoolId = this.$route.params.testId
            if (!scalePoolId) {
                scalePoolId = this.scaleModulesMsg ? this.scaleModulesMsg.scalePoolId : this.$route.query.scalePoolId
            }
            // console.log('--- 当前页面 scalePoolId ---', scalePoolId)
            let activityPage = this.$route.name == '20inPromotion'
            let activityScalePoolIds = [758, 761, 759, 760, 762, 767, 763, 765, 764, 766]
            console.log('--- 是否是双十一活动id ----', activityScalePoolIds.includes(Number(scalePoolId)))
            r = activityScalePoolIds.includes(Number(scalePoolId)) || activityPage
            // r = true
            console.log('--- 是否是双十一活动 ---', r)
            return r
        },
    },
    watch:{
    }
};



// WEBPACK FOOTER //
// ./src/mixins/globalMixin.js